import React from "react";
import { ModalPropsType } from "../../interface/modal";
import { Dialog } from "@mui/material";

export default function ModalContainer({
    sx,
    size = "sm",
    openModal,
    fullWidth = false,
    handleModal,
    children,
  }: ModalPropsType) {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          sx={{ borderRadius: "20px", ...sx }}
          maxWidth={size}
          open={openModal}
          scroll="paper"
          onClose={handleModal}
        >
          {children}
        </Dialog>
      </React.Fragment>
    );
  }